/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { FAVOURITES, CUSTOMERTOKEN, MYPROJECTS, LIVEPROJECTS, MYFAVOURITES, MYCUSTOMERS, MYADDEDCUSTOMERS, EDITADDEDCUSTOMERS, BUILDERS, RESET } from './mutation-types';

export default {
  [FAVOURITES](state, payload) {
    state.favourites = payload;
  },
  [CUSTOMERTOKEN](state, payload) {
    state.customerAccessToken = payload;
  },
  [MYPROJECTS](state, payload) {
    state.myProjects = payload.projects ? payload.projects : payload;
  },
  [LIVEPROJECTS](state, payload) {
    state.liveProjects = payload.projects ? payload.projects : payload;
  },
  [MYFAVOURITES](state, payload) {
    state.myFavourites = payload;
  },
  [MYCUSTOMERS](state, payload) {
    state.myCustomers = payload;
  },
  [MYADDEDCUSTOMERS](state, payload) {
    state.myAddedCustomers = payload;
  },
  [EDITADDEDCUSTOMERS](state, payload) {
    state.myAddedCustomers = payload;
  },
  [BUILDERS](state, payload) {
    state.builders = payload;
  },
  [RESET](state) {
    state.favourites = [];
    state.customerAccessToken = '';
    state.myFavourites = [];
    state.myProjects = [];
    state.liveProjects = [];
    state.myCustomers = {};
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/broker/mutations.js